
import Vue from 'vue';

import store from '@/store';
import router from '@/router';

import Menu, { MenuItem } from '@/components/menu.vue';
import Header from './header.vue';
import Footer from './footer.vue';
import { RouteName } from '@/router/routes';
import { mapActions, mapGetters } from 'vuex';

import { handlerAccesNonAuthorise } from '@/utils/auth/handler-acces-non-authorise';
import { BrsTiers } from '@/model/brs-tiers';
import { AgrFeedbackPopup } from '@agrial/ui';

function loadUserInfos () {
  if (store.getters['user/isTiers']) {
    return store.dispatch('tiers/loadInfosTiers', store.getters['user/user'].username);
  } else {
    return store.dispatch('user/loadListeRegionUser');
  }
}
function loadReferentiel () {
  return Promise.all([
    store.dispatch('referentiel/loadAll'),
    store.dispatch('preferenceUtilisateur/loadPreferenceUtilisateur', store.getters['user/user']?.username)
  ]);
}
export default Vue.extend({
  name: 'Main',
  components: {
    Menu,
    Header,
    Footer,
    AgrFeedbackPopup
  },
  data: () => ({
    showMenu: false
  }),
  computed: {
    ...mapGetters({
      infoTiers: 'tiers/infosTiers',
      listeregion: 'tiers/listeRegionUser',
      user: 'user/user',
      hasNouveautes: 'nouveautes/hasNew',
      alerteNouveautes: 'nouveautes/alerte',
      versions: 'infos/versions',
      favoritePage: 'preferenceUtilisateur/favoritePage'
    }),
    raisonSociale (): string | undefined {
      return (this.infoTiers as BrsTiers)?.raisonSociale;
    },
    username (): string | undefined {
      return this.user?.username;
    },
    badgeMenu (): boolean | string | number {
      return this.menuItems.some(item => item.badge);
    },
    menuItems () {
      const list = [
        new MenuItem('Tableau de bord', RouteName.MAIN_DASHBOARD, 'mdi-view-dashboard'),
        // new MenuItem('Mon compte', RouteName.MAIN_MON_COMPTE, 'mdi-account', false, false, Roles.USER_ADHERENT),
        new MenuItem('Alertes', RouteName.MAIN_ALERTES_LISTE, 'mdi-alarm', true),
        new MenuItem('Historique commandes', RouteName.MAIN_HISTORIQUE_COMMANDES, 'mdi-clipboard-text', false, false)
      ];
      if (this.hasNouveautes) {
        list.push(new MenuItem('Nouveautés', RouteName.MAIN_NOUVEAUTES, 'mdi-bell', false, this.alerteNouveautes));
      }
      return list;
    }
  },

  beforeRouteEnter (to, from, next) {
    store.dispatch('user/loadUser')
      .then(loadUserInfos)
      .then(loadReferentiel)
      .then(() => next())
      .catch(error => {
        // eslint-disable-next-line no-console
        console.warn(error);

        if (handlerAccesNonAuthorise(error, true)) {
          return;
        }

        let cause = null;
        try {
          if (error.response.data.code === 'TIERS_INEXISTANT') {
            cause = 'TIERS_NON_RECONNU';
            router.push({ name: 'error-logout', query: { cause } });
            return;
          }
        } catch (e) { }

        next(error);
      });
  },
  methods: {
    ...mapActions({ sessionLogout: 'session/logout' }),
    logout () {
      this.sessionLogout().finally(() => {
        this.$store.dispatch('reset');
        this.$router.push({ name: RouteName.LOGIN });
      });
    }

  }
});
